module.exports = __webpack_public_path__ + "img/emoji-happy.4ebc62b1.png";